import { render, staticRenderFns } from "./SongDetails.vue?vue&type=template&id=9b5973e8&scoped=true"
import script from "./SongDetails.vue?vue&type=script&lang=ts"
export * from "./SongDetails.vue?vue&type=script&lang=ts"
import style0 from "./SongDetails.vue?vue&type=style&index=0&id=9b5973e8&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b5973e8",
  null
  
)

export default component.exports